import { createSlice } from "@reduxjs/toolkit";
import { BzkndModel } from "app/model/common/bzkndModel";

const initialState: { bzknd: BzkndModel[], bzkndOnUsers: BzkndModel[] } = {
  bzknd: [],
  bzkndOnUsers: [],
};

const bzkndSlice = createSlice({
  name: 'bzknd',
  initialState,
  reducers: {
    updateBzknd: (state, action) => {
      state.bzknd = action.payload;
    },
    updateBzkndOnUsers: (state, action) => {
      state.bzkndOnUsers = action.payload;
    }
  }
});

export default bzkndSlice.reducer;
export const { updateBzknd, updateBzkndOnUsers } = bzkndSlice.actions;